import { ReceiveMessageBody, WebSocketMessageTypes } from '@/websocket/types'
import { WebSocketMessageMode } from '@/websocket/constants'
import WebSocketReceiver from '@/websocket/receivers/receiver'

export const enum WebSocketStatusMessageTypes {
  LOGIN = 'login',
  LOGOUT = 'logout'
}

export default class StatusWebSocketReceiver extends WebSocketReceiver<
  WebSocketMessageMode.STATUS
> {
  handleMessage(
    messageBody: ReceiveMessageBody<
      WebSocketMessageMode.STATUS,
      WebSocketMessageTypes<WebSocketMessageMode.STATUS>
    >
  ) {
    if (!messageBody) {
      return
    }

    switch (messageBody.type) {
      case WebSocketStatusMessageTypes.LOGIN:
        this.events.emit(WebSocketStatusMessageTypes.LOGIN, messageBody)
        break
      case WebSocketStatusMessageTypes.LOGOUT:
        this.events.emit(WebSocketStatusMessageTypes.LOGOUT, messageBody)
        break
      default:
        break
    }
  }
}
